module.exports = __webpack_public_path__ + "static/media/MobileDataPRATICANDOARQUITETURADEINTEGRAÇÃOCOMAPACHEKAFKASERVICEMESHISTIOAPIEMONGODB.4c225202.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/praticando/MobileDataPRATICANDOARQUITETURADEINTEGRAÇÃOCOMAPACHEKAFKASERVICEMESHISTIOAPIEMONGODB.png
// module id = 286
// module chunks = 0